import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  updateEntityListDataMultiple,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getFieldSetFieldListData,
  processAfterAddOrUpdateFieldSetFieldListData,
  processAfterDeleteFieldSetFieldListData,
} from './mockData'
import type { THrid } from '~/types/models'

// post

const postFieldSetField = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getFieldSetFieldListData,
    processAfterAddOrUpdateFieldSetFieldListData
  )
}

const patchFieldSetField = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getFieldSetFieldListData, [
    processAfterAddOrUpdateFieldSetFieldListData,
  ])
}
const patchFieldSetFields = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListDataMultiple(req, res, ctx, getFieldSetFieldListData)
}

const deleteFieldSetField = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  console.debug(
    '[api/msw/api/modules/fieldSetFields/index.ts] deleteFieldSetField | called'
  )
  return deleteEntityListData(
    req,
    res,
    ctx,
    getFieldSetFieldListData,
    processAfterDeleteFieldSetFieldListData
  )
}

export const handlers = [
  {
    method: 'post',
    path: '/api/fieldsetfields',
    handler: postFieldSetField,
  },
  {
    method: 'patch',
    path: '/api/fieldsetfields/:id',
    handler: patchFieldSetField,
  },
  {
    method: 'patch',
    path: '/api/fieldsetfields',
    handler: patchFieldSetFields,
  },
  {
    method: 'delete',
    path: '/api/fieldsetfields/:id',
    handler: deleteFieldSetField,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
